var exports = {
  "kL": "container__8BQadu",
  "lv": "overflowButton__hjzFsV",
  "rE": "squareAvatar__mvKDjj",
};

module.exports = exports;
